<template>
  <div class="editorBlogImage">
    <editor-image :data="data" />
  </div>
</template>

<script>
import EditorImage from '~/components/Editor/EditorImage';

export default {
  name: 'EditorBlogImage',
  components: {
    EditorImage,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.editorBlogImage {
  max-width: 106rem;
  padding: 0 2rem;
  margin: 0 auto 3rem;

  @include rwd('tablet') {
    margin: 0 auto 2rem;
  }
}
</style>
